// extracted by mini-css-extract-plugin
export var container = "styles-module--container--G-Zx1";
export var title = "styles-module--title--PtbI2";
export var cta = "styles-module--cta--UJR1G";
export var backAndForthRight = "styles-module--backAndForthRight--lofVo";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--aYV9Y";
export var animateBg = "styles-module--animateBg--T5lJq";